enum TREND_TYPE {
    HIGH='high',
    LOW='low',
    NO_CHANGE='no-change',
}
export default TREND_TYPE;
